import * as R from 'ramda';
import Address from './address';

function getGender(gender){
    if(R.is(String, gender)){
        const lowerCaseGender = gender.toLowerCase();
        switch(lowerCaseGender){
            case 'female':
                return 1;
            case 'male':
                return 2;
            default:
                return 0;
        }
    }else{
        return gender;
    }
    
}

function getRepresentativeType(representativeType){
    if(R.is(String, representativeType)){
        const lowerRepresentativeType = representativeType.toLowerCase();
        switch(lowerRepresentativeType){
            case 'child':
                return 1;
            case 'parent':
                return 2;
            case 'sibling':
                return 3;
            case 'spouse':
                return 4;
            case 'other':
                return 5;                                    
            default:
                return 0;
        }
    }else{
        return representativeType;
    }
    
}

export default function Referent(data){
    let referent = data || {};
    this.id = referent.id;
    this.email = R.isNil(referent.email) ? "" : referent.email;
    this.gender = getGender(referent.gender);
    this.firstName = R.isNil(referent.firstName) ? "" : referent.firstName;
    this.lastName = R.isNil(referent.lastName) ? "" : referent.lastName;
    this.birthDate = referent.birthDate === '0001-01-01T00:00:00Z' || R.isNil(referent.birthDate) ? undefined : new Date(referent.birthDate);
    this.representativeType = getRepresentativeType(referent.representativeType);
    this.isMainRepresentative = referent.isMainRepresentative;
    this.userId = referent.userId;
    this.address = referent.address !== undefined ? referent.address : undefined;
    this.tmpRef = referent.tmpRef !== undefined ? referent.tmpRef: undefined;
    this.phoneNumber = R.isNil(referent.phoneNumber) ? "" : referent.phoneNumber;
    this.addresses = referent.addresses !== undefined ? referent.addresses.map(a => new Address(a)) : [];
}